import {
  GET_AMLBOT_CREATE,
  GET_AMLBOT_OBTAIN,
  GET_AMLBOT_STATUS,
  GET_SUMSUB_CREATE,
  GET_SUMSUB_OBTAIN,
  GET_SUMSUB_STATUS,
} from "@/store/modules/user/consts";
import { isAmlbotKycProvider } from "@/utils/kycProvider";

export function getKycStoreActions() {
  if (isAmlbotKycProvider()) {
    return {
      create: GET_AMLBOT_CREATE,
      obtain: GET_AMLBOT_OBTAIN,
      status: GET_AMLBOT_STATUS,
    };
  }
  return {
    create: GET_SUMSUB_CREATE,
    obtain: GET_SUMSUB_OBTAIN,
    status: GET_SUMSUB_STATUS,
  };
}

export function parseKycStatusPayload(data) {
  return {
    status: typeof data === "object" ? data?.status : data,
    result: typeof data === "object" ? data?.result : null,
  };
}

export function isKycVerificationPassed(data) {
  const { status, result } = parseKycStatusPayload(data);
  return status === "completed" && (result === "GREEN" || !result);
}

export function isKycVerificationRejected(data) {
  const { status, result } = parseKycStatusPayload(data);
  return status === "completed" && result === "RED";
}

/**
 * Create session (or refresh link for AMLBot / token for SumSub).
 */
export async function fetchKycSession(store) {
  const actions = getKycStoreActions();
  let session = null;
  try {
    session = await store.dispatch(`user/${actions.create}`);
  } catch {
    // proceed to obtain
  }
  if (!session) {
    try {
      session = await store.dispatch(`user/${actions.obtain}`);
    } catch {
      // no session
    }
  }
  return session;
}

export async function fetchKycStatus(store) {
  const actions = getKycStoreActions();
  return store.dispatch(`user/${actions.status}`);
}
